module.exports = __webpack_public_path__ + "img/hunan.d6e60808.jpg";